import { classNamesFunction, getTheme, PrimaryButton, Stack, Text } from '@fluentui/react';
import React from 'react';
import { injectIntlWithObserver } from '../../../utils';
import { onNewReportClicked } from '../@data/actions';
import { SectionLayout } from './components/SectionLayout';
import message from './LandingPage.messages';
import { getStyles } from './LandingPage.styles';
import { IReportLandingPageProps, IReportLandingPageStyleProps, IReportLandingPageStyles } from './LandingPage.types';
import { ReactComponent as AnnotationIcon } from './resources/Annotation.svg';
import { ReactComponent as CheckMarkIcon } from './resources/Checkmark Progress.svg';
import { ReactComponent as DataTrendingIcon } from './resources/Data Trending.svg';

export const ReportLandingPage = injectIntlWithObserver<IReportLandingPageProps>((props: IReportLandingPageProps) => {
  const getClassNames = classNamesFunction<IReportLandingPageStyleProps, IReportLandingPageStyles>();
  const classNames = getClassNames(getStyles, { theme: getTheme() });
  const { formatMessage } = props.intl;

  const sections = [
    {
      title: formatMessage(message.landingPageFirstSectionTitle),
      description: formatMessage(message.landingPageFirstSectionDescription),
      Icon: CheckMarkIcon,
    },
    {
      title: formatMessage(message.landingPageSecondSectionTitle),
      description: formatMessage(message.landingPageSecondSectionDescription),
      Icon: AnnotationIcon,
    },
    {
      title: formatMessage(message.landingPageThirdSectionTitle),
      description: formatMessage(message.landingPageThirdSectionDescription),
      Icon: DataTrendingIcon,
    },
  ];
  return (
    <Stack verticalAlign="center" horizontalAlign="center" className={classNames.root}>
      <Text className={classNames.title}>{formatMessage(message.landingPageTitle)}</Text>
      <Text className={classNames.description}>
        {formatMessage(message.landingPageFirstDescription)} <br /> {formatMessage(message.landingPageSecondDescription)}
      </Text>
      <Stack tokens={{ childrenGap: 40 }} verticalAlign="center" horizontal className={classNames.sectionsStyle}>
        {sections.map((section, index) => (
          <SectionLayout key={index} {...section} />
        ))}
      </Stack>
      <Stack tokens={{ childrenGap: 16 }} horizontal>
        <PrimaryButton
          tabIndex={0}
          onClick={onNewReportClicked}
          className={classNames.primaryButton}
          text={formatMessage(message.landingPageNewReportExperience)}
          aria-describedby="New Report"
        />
      </Stack>
    </Stack>
  );
});
